import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-note-subtitle-form',
  templateUrl: './note-subtitle-form.component.html',
  styleUrls: ['./note-subtitle-form.component.scss']
})
export class NoteSubtitleFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
